import { type FC, useEffect } from "react";

import { Alert } from "@hightouch/htui";

import { LinkButton } from "src/router";

import { useUser } from "src/contexts/user-context";
import * as analytics from "src/lib/analytics";

export const IncidentBanner: FC<{
  title: string;
  message: string;
  onDismiss: () => void;
}> = ({ title, message, onDismiss }) => {
  const { workspace } = useUser();

  // TODO(eric.lovett): This `biome-ignore` was part of a blanket suppression so that we could
  // turn on the rule. It is probably covering up a real bug. Please fix this or replace this
  // TODO with an explanation of why we don't want all deps listed.
  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy suppression, probably a bug
  useEffect(() => {
    analytics.track("Incident Banner Shown", {
      workspace_id: workspace?.id,
    });
  }, []);

  return (
    <Alert
      variant="banner"
      type="warning"
      title={title}
      message={message}
      actions={
        <LinkButton
          target="_blank"
          href={import.meta.env.VITE_STATUS_PAGE_URL}
          onClick={() => {
            analytics.track("Incident Banner Status Page Clicked", {
              workspace_id: workspace?.id,
            });
          }}
        >
          View status page
        </LinkButton>
      }
      onDismiss={onDismiss}
    />
  );
};
